export default __webpack_public_path__ + "static/media/google-cloud-3.b86eb7e3.svg";